<script>
import TablePage from '@/found/components/table_page';
import Form from '../form';

export default {
  extends: TablePage,
  components: {
    // Modal,
    Form,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
    };
  },
  mounted() {
    this.getConfigList('dms_contract_element_table');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add') {
        // this.modalConfig.width = '400px';
        this.openModal();
      } else if (val.code === 'edit') {
        this.formConfig = row;
        // this.modalConfig.width = '400px';
        this.openModal();
      }
    },
  },
};
</script>
